@if (data === undefined || data !== undefined && data.length > 0) {
<div class="recommender" [ngClass]="{ 'recommender--with-large-title': titleLargeDesktop }">
  @if (title) {
    <app-content>
      <div class="recommender__top" [ngClass]="{ 'recommender__top--with-link': listLink, 'recommender__top--desktop-large': titleLargeDesktop }">
        <div class="recommender__top-title">
          @if (titleLargeDesktop) {
            <app-title class="recommender__large-title" [tag]="'h2'">{{ 'recommender.title' | translate }}</app-title>
          }
          <app-small-title class="recommender__small-title" [color]="titleColor">{{ title }}</app-small-title>
        </div>
        @if (listLink) {
          <app-underline-link [route]="globals.routes()['list'].url" [color]="'primary'">{{ 'recommender.showAll' | translate }}</app-underline-link>
        }
      </div>
    </app-content>
  }
  <app-slider [item-width]="300" [padding]="true" [data]="data" (activeChange)="changed()">
    @if (data !== undefined) {
      @for (car of data; track car.id) {
        <app-slider-item>
          <app-car-card [car]="car" [is-reccommender]="true"></app-car-card>
        </app-slider-item>
      }
    } @else {
      @for (number of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]; track number) {
        <app-slider-item>
          <app-card>
            <app-card-loader></app-card-loader>
          </app-card>
        </app-slider-item>
      }
    }
  </app-slider>
</div>
}